<script>
  import Header from "../components/Header.svelte";
  import { linkTree } from "../json/linkTree";
</script>

<link rel="preconnect" href="https://fonts.gstatic.com" />
<link
  href="https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap"
  rel="stylesheet"
/>

<Header />

<main>
  {#each linkTree as { id, name, link, target } (id)}
    <a href={link} btn-name={name} target={target ? target : "_blank"}>{name}</a
    >
  {/each}
</main>

<style>
  main {
    padding: 1em;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  a {
    cursor: pointer;
    margin: auto;
    width: 800px;
    height: 50px;
    margin-top: 1em;
    color: #fff;
    text-align: center;
    text-decoration: none;
  }

  a,
  a::after {
    font-size: 30px;
    font-family: "Bebas Neue", cursive;
    background: linear-gradient(45deg, transparent 3%, #0f4c75 3%);
    border: 0;
    color: #fff;
    letter-spacing: 3px;
    line-height: 50px;
    box-shadow: 6px 0px 0px #1fab89;
    box-shadow: 6px 0px 0px #598392;
    outline: transparent;
    position: relative;
  }

  a::after {
    --slice-0: inset(50% 50% 50% 50%);
    --slice-1: inset(80% -6px 0 0);
    --slice-2: inset(50% -6px 30% 0);
    --slice-3: inset(10% -6px 85% 0);
    --slice-4: inset(40% -6px 43% 0);
    --slice-5: inset(80% -6px 5% 0);

    content: "AVAILABLE NOW";
    content: attr(btn-name);

    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-shadow: -3px -3px 0px #f8f005, 3px 3px 0px #00e6f6;
    clip-path: var(--slice-0);
  }

  a:hover::after {
    animation: 1s glitch;
    animation-timing-function: steps(2, end);
  }

  @keyframes glitch {
    0% {
      clip-path: var(--slice-1);
      transform: translate(-20px, -10px);
    }
    10% {
      clip-path: var(--slice-3);
      transform: translate(10px, 10px);
    }
    20% {
      clip-path: var(--slice-1);
      transform: translate(-10px, 10px);
    }
    30% {
      clip-path: var(--slice-3);
      transform: translate(0px, 5px);
    }
    40% {
      clip-path: var(--slice-2);
      transform: translate(-5px, 0px);
    }
    50% {
      clip-path: var(--slice-3);
      transform: translate(5px, 0px);
    }
    60% {
      clip-path: var(--slice-4);
      transform: translate(5px, 10px);
    }
    70% {
      clip-path: var(--slice-2);
      transform: translate(-10px, 10px);
    }
    80% {
      clip-path: var(--slice-5);
      transform: translate(20px, -10px);
    }
    90% {
      clip-path: var(--slice-1);
      transform: translate(-10px, 0px);
    }
    100% {
      clip-path: var(--slice-1);
      transform: translate(0);
    }
  }

  @media screen and (max-width: 992px) {
    a {
      width: 100%;
    }
  }
</style>
